const validarCpf = (cpf) => {
    if (cpf != '') {
        if ((cpf = cpf.replace(/[^\d]/g, '').split('')).length != 11) {
            return false;
        }

        if ((new RegExp('^' + cpf[0] + '{11}$')).exec(cpf.join(''))) {
            return false;
        }

        for (var s = 10, n = 0, i = 0; s >= 2; n += cpf[i++] * s--) {}

        if (cpf[9] != ((n %= 11) < 2 ? 0 : 11 - n)) {
            return false;
        }

        for (var s = 11, n = 0, i = 0; s >= 2; n += cpf[i++] * s--) {}

        if (cpf[10] != ((n %= 11) < 2 ? 0 : 11 - n)) {
            return false;
        }
        
        return true;
    } else {
        return true;
    }
}

const validarCnpj = (cnpj) => {
    if (typeof cnpj !== 'string') return false;
    if (!cnpj) return false;

    // Remove pontuação e normaliza
    cnpj = cnpj.toUpperCase().replace(/[.\-\/]/g, '');

    // Deve ter 14 caracteres
    if (cnpj.length !== 14) return false;

    const charToValue = (c) => {
        const code = c.charCodeAt(0);
        const val = code - 48;

        return (val >= 0 && val <= 42) ? val : -1;
    };

    const valores = [];

    for (let i = 0; i < cnpj.length; i++) {
        const v = charToValue(cnpj[i]);
        if (v < 0) return false;
        valores.push(v);
    }

    const pesos = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    // Primeiro DV
    let soma = 0;
    for (let i = 0; i < 12; i++) {
        soma += valores[i] * pesos[i + 1];
    }

    let resto = soma % 11;
    const dv1 = resto < 2 ? 0 : 11 - resto;

    if (valores[12] !== dv1) return false;

    // Segundo DV
    soma = 0;
    for (let i = 0; i < 13; i++) {
        soma += valores[i] * pesos[i];
    }

    resto = soma % 11;
    const dv2 = resto < 2 ? 0 : 11 - resto;

    if (valores[13] !== dv2) return false;

    return true;
};

export { validarCpf, validarCnpj };